"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMarketSpecificSoftware = void 0;
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable import/prefer-default-export */
var await_timeout_1 = __importDefault(require("await-timeout"));
var DeviceCharacteristic_1 = require("../../../common/DeviceCharacteristic");
var dataViewParsers_1 = require("../control/parsers/dataViewParsers");
var dataViewParsers_2 = require("../challenge/parsers/dataViewParsers");
var MSSProgressState_1 = require("../../../bluetoothClient/MSSProgressState");
/**
 *
 * @param device
 */
var stopNotifications = function (device) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, device.stopNotifications(device.profile.DEVICE_MANAGEMENT.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.DeviceManagementCharacteristics.CHALLENGE; }).uuid)];
            case 1:
                _a.sent();
                return [4 /*yield*/, device.stopNotifications(device.profile.DEVICE_MANAGEMENT.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.DeviceManagementCharacteristics.CONTROL; }).uuid)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
/**
 * HandlePayloadChallengeNotifications
 * @param device
 * @param request
 */
var handlePayloadChallengeNotifications = function (device, request, parsedChallengeNotificationResponse) { return __awaiter(void 0, void 0, void 0, function () {
    var requestPayload, parsedPayload, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.ChallengeGenerated);
                // 3. Call Backend to get MSS JSON Payload
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.SendChallenge);
                return [4 /*yield*/, device.requestPayload({
                        challenge: parsedChallengeNotificationResponse.payloadChallengeResponse,
                        country_code: request.countryCode,
                        payload_code: request.payloadCode,
                        apiParams: request.apiParams,
                    })];
            case 1:
                requestPayload = _a.sent();
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.ChallengeSent);
                // 4. Prepare Payload for upload (parse into an array of chunks of Split BufferArray)
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.RetrieveConfigurationFile);
                return [4 /*yield*/, device.parsePayload(requestPayload)];
            case 2:
                parsedPayload = _a.sent();
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.ConfigurationFileRetrieved);
                device.payloadUploadState = { chunks: parsedPayload.payload.length, uploaded: 0 };
                // 5. Write PayloadVersion into the device
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.WriteVersion);
                return [4 /*yield*/, device
                        .setPayloadVersion({ payloadByteSize: parsedPayload.payloadByteSize })
                        .then(function () { return device.mssProgressChanged(MSSProgressState_1.MSSProgressState.VersionWritten); })];
            case 3:
                _a.sent();
                // Save parsed payload on device instance
                device.parsedPayload = parsedPayload;
                return [3 /*break*/, 5];
            case 4:
                error_1 = _a.sent();
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.HttpError);
                return [2 /*return*/, error_1];
            case 5: return [2 /*return*/];
        }
    });
}); };
/**
 * HandlePayloadControlNotifications
 * @param device
 * @param request
 */
var handlePayloadControlNotifications = function (device, controlRequest) { return __awaiter(void 0, void 0, void 0, function () {
    var error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 7]);
                if (controlRequest.payloadControlResponse === 5) {
                    device.mssProgressChanged(MSSProgressState_1.MSSProgressState.Error);
                    throw new Error('Payload upload failed');
                }
                if (!(controlRequest.payloadControlResponse === 1 ||
                    controlRequest.payloadControlResponse === 2)) return [3 /*break*/, 3];
                return [4 /*yield*/, device.uploadPayload(device)];
            case 1:
                _a.sent();
                return [4 /*yield*/, await_timeout_1.default.set(200)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                if (!(controlRequest.payloadControlResponse === 4)) return [3 /*break*/, 5];
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.PayloadUploadVerified);
                return [4 /*yield*/, stopNotifications(device)];
            case 4:
                _a.sent();
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.Completed);
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.Disconnecting);
                device.disconnect();
                _a.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                error_2 = _a.sent();
                return [2 /*return*/, error_2];
            case 7: return [2 /*return*/];
        }
    });
}); };
/**
 * Subscribe to required Notifications
 *
 * @param device
 */
var startNotifications = function (device, request) { return __awaiter(void 0, void 0, void 0, function () {
    var error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, device.startNotifications(device.profile.DEVICE_MANAGEMENT.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.DeviceManagementCharacteristics.CHALLENGE; }).uuid, function (e) {
                        return handlePayloadChallengeNotifications(device, request, (0, dataViewParsers_2.parsePayloadChallenge)(e.target.value));
                    })];
            case 1:
                _a.sent();
                return [4 /*yield*/, device.startNotifications(device.profile.DEVICE_MANAGEMENT.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.DeviceManagementCharacteristics.CONTROL; }).uuid, function (e) { return handlePayloadControlNotifications(device, (0, dataViewParsers_1.parsePayloadControlStatus)(e.target.value)); })];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                error_3 = _a.sent();
                return [2 /*return*/, error_3];
            case 4: return [2 /*return*/];
        }
    });
}); };
var setMarketSpecificSoftware = function (device, request) { return __awaiter(void 0, void 0, void 0, function () {
    var error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                // 1. Subscribe to required notifications
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.Idle);
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.StartMSS);
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.SubscribeToNotifications);
                return [4 /*yield*/, startNotifications(device, request)];
            case 1:
                _a.sent();
                return [4 /*yield*/, await_timeout_1.default.set(2000)];
            case 2:
                _a.sent();
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.SubscribedToNotifications);
                // 2. Generate new Challenge
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.WritePayloadCode);
                return [4 /*yield*/, device.setPayloadChallenge({ payloadChallengeCode: request.challengeCode })];
            case 3:
                _a.sent();
                device.mssProgressChanged(MSSProgressState_1.MSSProgressState.PayloadCodeWritten);
                return [3 /*break*/, 5];
            case 4:
                error_4 = _a.sent();
                return [2 /*return*/, error_4];
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.setMarketSpecificSoftware = setMarketSpecificSoftware;
